<div class="login-container">
  <div *ngIf="isContentfulActive" [ngClass]="serviceName" class="login-info">
    <div>
      <app-cms-content
        [key]="'services.login-' + serviceName"
        [placeholder]="serviceName"
      ></app-cms-content>
      <div class="login-info__character" [ngClass]="serviceName"></div>
    </div>
    <div class="login-info__logo" [ngClass]="serviceName"></div>
  </div>

  <div class="login-panel forms-design-system buttons-design-system">
    <div>
      <div class="login-panel__logo--image" [ngClass]="serviceName"></div>

      <div class="otp-panel__title">{{ 'otp.title' | translate }}</div>
      <p class="otp-panel__subtitle">{{ 'otp.subtitle' | translate }}</p>

      <div>
        <div class="otp-panel__label-row">
          <span class="otp-panel__label">{{ 'otp.codeLabel' | translate }}</span>
          <span *ngIf="attemptsLeft < 3" class="otp-panel__attempts">
            {{ attemptsLeft }} {{ 'otp.attemptsLeft' | translate }}
          </span>
        </div>

        <div class="otp-panel__digits" (paste)="onPaste($event)">
          <input
            *ngFor="let i of [0, 1, 2, 3, 4, 5]"
            [id]="'otp-' + i"
            #otpInput
            class="otp-panel__digit"
            type="text"
            inputmode="numeric"
            autocomplete="off"
            maxlength="1"
            [attr.aria-label]="('otp.digitLabel' | translate) + ' ' + (i + 1)"
            (keyup)="onDigitInput($event, i)"
          />
        </div>

        <div *ngIf="otpError" class="form__error otp-panel__error">
          <span class="glicon-alert-thin"></span>
          <app-dynamic-form-error [formError]="otpError"></app-dynamic-form-error>
          <span> </span>
        </div>

        <div class="otp-panel__timer">
          <gl-icon icon="glicon-indicator-pitch-time"></gl-icon>
          <span>
            {{ 'otp.expiresIn' | translate }}
          </span>
        </div>

        <gl-button
          color-primary
          full-width
          [text]="'otp.verify' | translate"
          [disabled]="!hasOtpValid"
          (onClick)="submit()"
        >
        </gl-button>

        <div class="otp-panel__resend">
          <span *ngIf="resendCooldown > 0" class="otp-panel__cooldown">
            {{ 'otp.waitingResend' | translate }} ({{ resendCooldown }}s)
          </span>
          <gl-button
            *ngIf="resendCooldown <= 0"
            color-tertiary
            [text]="'otp.resend' | translate"
            (onClick)="resendOtp()"
          ></gl-button>
        </div>
      </div>
      <div class="otp-panel__login">
        <gl-button
          color-secondary
          [text]="'otp.backToLogin' | translate"
          (onClick)="backToLogin()"
        ></gl-button>
      </div>

      <hr class="otp-panel__divider" />

      <div class="otp-panel__help">
        <span>{{ 'auth.helpQuestion' | translate }}</span>
        <a href="{{ supportUrl }}" target="_blank" title="Support">
          {{ 'auth.contactLabel' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
